import { render, staticRenderFns } from "./data40.vue?vue&type=template&id=4aafddb8&scoped=true&"
import script from "./data40.vue?vue&type=script&lang=js&"
export * from "./data40.vue?vue&type=script&lang=js&"
import style1 from "./data40.vue?vue&type=style&index=1&id=4aafddb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aafddb8",
  null
  
)

export default component.exports